/*
  PawsLife Konfigurator - alle sichtbaren Texte an einer Stelle
  ------------------------------------------------------------------
  Hier stehen die deutschen Standardtexte fuer alles, was per JavaScript
  angezeigt wird (Konfigurator, Fotoupload, Warenkorb-Meldungen, Banner
  "Weitermachen"). Uebersetzungen kommen aus dem Metaobject
  configurator_settings -> ui_translations: dort gesetzte Werte gewinnen,
  dieser Standard fuellt nur die Luecken.

  Neuen Text einbauen: Schluessel hier ergaenzen und im Code ueber
  pawsText('schluessel') lesen. Platzhalter in geschweiften Klammern
  werden ueber das zweite Argument gefuellt: pawsText('resume_step', { step: 3 }).
*/
(function () {
  var standard = {
    /* Fotoupload */
    upload_btn_change: 'Foto ändern',
    upload_no_preview: 'Vorschau in diesem Format nicht möglich. Dein Foto ist trotzdem gespeichert.',

    /* Fotoupload im TeeInBlue-Personalisierer: Warteanimation.
       Der Vorgang hat zwei sehr ungleiche Haelften. Das Uebertragen dauert
       seit der Vorab-Verkleinerung (tib-photo-compress.js) nur noch wenige
       Sekunden; die Umwandlung durch Gemini bleibt bei etwa 15-30 Sekunden,
       weil sie auf fremden Servern laeuft und von uns nicht zu beschleunigen
       ist. Genau dort springen Kunden ab, wenn nichts passiert - deshalb
       wechselnde Saetze und ein sichtbarer Fortschritt.
       Bewusst KEINE Schrittzaehlung ("Schritt 1 von 2"): fuer den Kunden ist
       das ein einziger Vorgang, eine Nummerierung wirft nur die Frage auf,
       was der zweite Schritt sein soll. */
    photo_wait_title_upload: 'Dein Foto kommt bei uns an',
    photo_wait_title_ai: 'Dein Kunstwerk entsteht',
    photo_wait_hint: 'Bitte lass die Seite offen – das dauert meist nur wenige Sekunden.',
    /* Wird ab ca. 25 Sekunden statt photo_wait_hint gezeigt. Der Grund ist
       nicht mehr die Dateigroesse - die ist vor dem Upload gedeckelt -,
       sondern die Rechenzeit der Bildumwandlung. Ein Text, der dem Kunden
       einen falschen Grund nennt, macht das Warten nur aergerlicher. */
    photo_wait_hint_slow: 'Gleich geschafft. Der letzte Feinschliff dauert einen Moment – es lohnt sich.',
    photo_wait_done: 'Fertig! Schau Dir Dein Ergebnis an.',
    photo_wait_alt: 'Dein Foto wird verarbeitet',
    /* Ein Satz je Szene der Warteanimation. Die Reihenfolge der Listen ist die
       Anzeigereihenfolge; bei jedem Durchlauf rueckt der Satz eine Stelle
       weiter, damit sich in einer langen Wartezeit nichts wiederholt.
       Wer uebersetzt: Der Satz muss zum Bild passen, das gerade laeuft. */
    photo_wait_lines_mix: [
      'Die Farbe wird angerührt – Deine ganz eigene Mischung.',
      'Wir schauen Deinem Liebling gerade tief in die Augen …',
      'Der richtige Ton für das Fell wird gesucht.'
    ],
    photo_wait_lines_palette: [
      'Auf der Palette entsteht Dein Farbton.',
      'Warm oder kühl? Wir mischen, bis es passt.',
      'Zwei Farben, ein Ton – genau für Dein Bild.'
    ],
    photo_wait_lines_brush: [
      'Der erste Pinselstrich sitzt.',
      'Der Hintergrund wird sauber freigestellt.',
      'Schicht für Schicht kommt Farbe aufs Bild.'
    ],
    photo_wait_lines_measure: [
      'Das Motiv wird ausgerichtet – Millimeterarbeit.',
      'Wir prüfen den Bildausschnitt, damit nichts verloren geht.',
      'Alles wird vermessen, damit es später perfekt sitzt.'
    ],
    photo_wait_lines_frame: [
      'Gute Kunst braucht einen Moment. Deine auch.',
      'Fast fertig – es lohnt sich, kurz zu bleiben.',
      'Noch ein Wimpernschlag, dann siehst Du das Ergebnis.'
    ],

    /* Fotoupload: Kachelreihe der bereits hochgeladenen Bilder */
    photo_gallery_title_one: 'Dein Foto',
    photo_gallery_title_many: 'Deine Fotos ({anzahl})',
    photo_gallery_hint_many: 'Tippe ein Foto an, um es zu verwenden.',
    photo_gallery_hint_one: 'Du kannst Dein Foto jederzeit austauschen.',
    photo_gallery_add: 'Foto hinzufügen',
    photo_gallery_add_only: 'Foto auswählen',
    photo_gallery_active: 'Wird verwendet',
    photo_gallery_use: 'Dieses Foto verwenden',

    /* Fotoupload: Hinweise VOR der Auswahl.
       Bei KI-Produkten entscheidet die Fotoqualitaet ueber das Ergebnis - ein
       enttaeuschtes "so sieht mein Hund nicht aus" kostet zweimal: Abbruch
       jetzt oder Retoure spaeter. Deshalb kurz und konkret, nicht belehrend.
       Sichtbar nur, solange noch kein Foto gewaehlt ist. */
    /* Bewusst je EIN kurzer Satz: in der schmalen Personalisierungsspalte
       (ca. 220 px Textbreite) braucht jeder laengere Punkt zwei Zeilen und
       schiebt Knopf und Preis nach unten. */
    photo_tips_title: 'So gelingt Dein Bild am besten',
    photo_tips_lines: [
      'Tageslicht statt Blitz.',
      'Nah dran, Kopf gut erkennbar.',
      'Originalfoto statt Screenshot.'
    ],
    /* Nur bei Produkten mit KI-Effekt. Wer die Wartezeit vorher kennt, wartet;
       wer ueberrascht wird, klickt weg. */
    photo_tips_time: 'Dauert ca. 30 Sekunden.',
    photo_tips_privacy: 'Dein Foto nutzen wir nur für Deine Bestellung.',

    /* Warenkorb */
    atc_busy: 'Wird hinzugefügt …',
    atc_busy_photos: 'Fotos werden hochgeladen …',
    atc_busy_progress: 'Fotos werden hochgeladen … {prozent} %',
    atc_busy_finish: 'Fast fertig …',
    atc_busy_checkout: 'Weiter zur Kasse …',
    atc_retry: 'Erneut versuchen',
    /* Angezeigt, wenn die Konfiguration schon im Warenkorb liegt (Zurueck aus der Kasse) */
    atc_in_cart_checkout: 'Weiter zur Kasse',
    atc_in_cart_link: 'oder Warenkorb ansehen',
    atc_error_variant: 'Die gewählte Option konnte nicht übernommen werden. Bitte wähle Deine Variante erneut aus.',
    atc_error_generic: 'Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    atc_error_timeout: 'Die Verbindung war zu langsam. Bitte versuche es erneut.',
    atc_error_network: 'Es gab einen unerwarteten Fehler. Bitte prüfe Deine Verbindung und versuche es erneut.',
    atc_error_server: 'Der Shop ist aktuell leider nicht erreichbar. Bitte versuche es gleich noch einmal.',

    /* Banner "Weitermachen, wo du aufgehoert hast" */
    resume_title: 'Du hattest hier schon angefangen',
    resume_step: 'bei Schritt {step}: {name}',
    resume_continue: 'Weitermachen',
    resume_restart: 'Neu beginnen',

    /* Handyhuellen-Auswahl */
    phone_placeholder: 'Bitte Modell wählen',
    phone_error: 'Bitte wähle Dein Modell aus.',

    /* Zusatzprodukte */
    upsell_no_upgrade: 'Kein Upgrade',
    addons_title: 'Mach es komplett',
    addons_subtitle: 'Beliebte Ergänzungen. Nur jetzt zusammen bestellbar.',
    upsell_save: 'Du sparst {prozent} %',
    /* Fallback fuer alle Zusatzprodukte ohne eigenes "social_proof" in upsell_v1.json */
    upsell_social: '',
    addons_more: 'Weitere Extras anzeigen ({anzahl})',

    /* Zusammenfassung */
    review_title: 'Deine Auswahl',
    review_remove: '{titel} entfernen',
    review_photo_ok: 'Foto {nr}',
    review_pet_name: 'Name',
    review_pet_name_n: 'Name {nr}',
    review_open: 'Details anzeigen',
    review_close: 'Details ausblenden',

    /* Schoenere Beschriftungen fuer technische Feldnamen aus dem Warenkorb */
    review_labels: {
      Brand: 'Marke',
      Model: 'Modell'
    },

    /* Preisdifferenz an den Groessenkacheln */
    size_delta_zero: 'ohne Aufpreis',
    size_delta_bonus: '{betrag} mehr Rabatt',

    /* Eckband auf der meistgewaehlten Kachel. Welche Kachel es traegt,
       steht im Metafeld custom.configurator_bestseller - hier steht nur
       die Beschriftung. Kurz halten: die schmalste Groessenkachel ist
       rund 100 Pixel breit. */
    bestseller_badge: 'Bestseller',

    /* Zufriedenheitsgarantie / Freigabe vor dem Druck. Steht als Karte im
       letzten Schritt, gebaut von garantieAufbauen() in
       assets/paws-configurator.js.
       Rechtlicher Rahmen: die Zusage bezieht sich ausschliesslich auf die
       Zeit VOR dem Druck. Kein Widerruf, keine Ruecknahme - bei
       personalisierter Ware waere das angreifbar und teuer. */
    guarantee_headline: 'Volle Kontrolle: Wir fertigen Dein Unikat erst nach Deiner Freigabe.',
    guarantee_steps: [
      'Wir starten sofort mit der Gestaltung und senden Dir Deinen Entwurf zur Vorschau.',
      'Kostenloser Feinschliff: Wir passen alles an, bis jedes Detail perfekt sitzt.',
      'Erst nach Deinem finalen „Go“ geht Dein Unikat in die Fertigung.'
    ],
    guarantee_note: 'Passt etwas nicht, ändern wir es kostenlos, bis Du zufrieden bist.',

    /* Kaufleiste in Variante B: Fuehrungszustand des Knopfes.
       Der Text benennt die fehlende Angabe, nicht den Schritt-Titel -
       Titel sind ganze Fragen und sprengen die Knopfbreite. */
    sticky_guide_upload: 'Weiter: Foto hochladen \u2193',
    sticky_guide_text: 'Weiter: Text eingeben \u2193',
    sticky_guide_select: 'Weiter: Auswahl treffen \u2193'
  };

  // Das Snippet schreibt die Uebersetzungen aus dem Metaobject bereits hierhin.
  var texte = window.PAWS_TEXTE || (window.PAWS_TEXTE = {});
  Object.keys(standard).forEach(function (schluessel) {
    if (texte[schluessel] === undefined || texte[schluessel] === null || texte[schluessel] === '') {
      texte[schluessel] = standard[schluessel];
    }
  });

  window.pawsText = function (schluessel, werte) {
    var roh = texte[schluessel];
    if (typeof roh !== 'string') return '';
    if (!werte) return roh;
    return roh.replace(/\{(\w+)\}/g, function (treffer, name) {
      return werte[name] === undefined || werte[name] === null ? '' : String(werte[name]);
    });
  };

  // Fuer Schluessel, die eine Liste sind (z.B. die Wartesaetze beim Fotoupload).
  // Ein einzelner String wird als Liste mit einem Eintrag geliefert, damit
  // Uebersetzungen aus dem Metaobject auch als Zeile pro Satz funktionieren.
  window.pawsTextListe = function (schluessel) {
    var roh = texte[schluessel];
    if (Array.isArray(roh)) return roh.filter(function (z) { return typeof z === 'string' && z.trim() !== ''; });
    if (typeof roh === 'string' && roh.trim() !== '') {
      return roh.split('\n').map(function (z) { return z.trim(); }).filter(Boolean);
    }
    return [];
  };
}());